import { render, staticRenderFns } from "./ReserveItem.vue?vue&type=template&id=6ec9c8a5&scoped=true&"
import script from "./ReserveItem.vue?vue&type=script&lang=js&"
export * from "./ReserveItem.vue?vue&type=script&lang=js&"
import style0 from "./ReserveItem.vue?vue&type=style&index=0&id=6ec9c8a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9c8a5",
  null
  
)

export default component.exports